import React from 'react'

import Div from './styles'
import { Props } from './types'

const Columns: React.FC<Props> = ({
  children, ...props
}): React.ReactElement => (
  <Div {...props}>
    {children}
  </Div>
)

export * from './types'

export default Columns
